export default {
      id: "overflow-menu-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#overflow-menu",
      toString: function () {
        return this.url;
      }
    }